import { render, staticRenderFns } from "./salesMergeQxOrderAction.vue?vue&type=template&id=1f232012&scoped=true"
import script from "./salesMergeQxOrderAction.vue?vue&type=script&lang=js"
export * from "./salesMergeQxOrderAction.vue?vue&type=script&lang=js"
import style0 from "./salesMergeQxOrderAction.vue?vue&type=style&index=0&id=1f232012&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f232012",
  null
  
)

export default component.exports